transformFacetOption